/**
 * 브라우저 자동 번역(Edge/Chrome 번역, Google Translate)은 DOM 텍스트 노드를
 * <font> 태그로 감싸 React 가 알고 있는 트리와 실제 DOM 을 어긋나게 만든다.
 * 이후 React 가 원래 위치의 노드를 removeChild/insertBefore 하려는 순간
 * NotFoundError 가 던져지고, 에러 바운더리가 없으면 트리 전체가 언마운트되어
 * 빈 화면이 된다 (facebook/react#11538).
 *
 * 노드가 이미 다른 부모로 옮겨진 경우 조용히 복구해 커밋이 죽지 않게 한다.
 * 이 모듈은 React 렌더 이전(main.tsx 최상단)에 임포트되어야 한다.
 */
let onIntercept: (() => void) | null = null

/** 가드가 실제로 개입했을 때 알림받을 콜백 (에러 리포터의 브레드크럼용) */
export function setDomTranslationGuardObserver(callback: (() => void) | null): void {
  onIntercept = callback
}

function notifyIntercept(): void {
  try {
    onIntercept?.()
  } catch {
    // 옵저버 실패가 DOM 조작을 깨뜨리면 안 된다
  }
}

export function installDomTranslationGuard(): void {
  if (typeof Node !== 'function' || !Node.prototype) return

  const originalRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      // 번역기가 노드를 옮겨갔다 — 제거된 것으로 간주하고 통과시킨다
      notifyIntercept()
      return child
    }
    return originalRemoveChild.call(this, child) as T
  }

  const originalInsertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function <T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null,
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      // 기준 노드가 옮겨졌으면 맨 뒤에 붙인다 (다음 React 커밋이 순서를 복원)
      notifyIntercept()
      return originalInsertBefore.call(this, newNode, null) as T
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T
  }
}
